import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import { Globals } from "../globals";
import { APP_VERSION } from "../version";
import { useColorScheme } from "../hooks/useColorScheme";

export default function AppFooter() {
    const { t } = useTranslation();
    const { scheme } = useColorScheme();

    return (
        <footer className="gl-footer">
            <p className="mb-1">
                <Link to={Globals.PATH_IMPRESSUM}>{t("footer.impressum")}</Link>
                <Link to={Globals.PATH_DATENSCHUTZ}>{t("footer.privacy")}</Link>
                <Link to={Globals.PATH_NUTZUNGSBEDINGUNGEN}>{t("footer.terms")}</Link>
            </p>
            <p className="gl-footer-copy mb-0">© {new Date().getFullYear()} Serva · v{APP_VERSION}</p>
            {/* Sender (GOD-57): the jw29435 mark only appears here. */}
            <div className="gl-footer-sender">
                <img src={scheme === "dark" ? "/jw-amber-mark-dark.png" : "/jw-amber-mark.png"} alt="" />
                <span>
                    {t("footer.productBy")} <b>jw29435</b>
                </span>
            </div>
        </footer>
    );
}
